import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';



import threeDotIcon from '../../assets/img/icons/three-dot-green.svg';


const IconBox = styled.div`
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: #edf8ff;

  &:hover {
    /* background-color: ${({ theme }) => theme.colors.hover.gray}; */
    background-color: ${({ theme }) => theme.colors.main.primaryLight};
  }
`;

const IconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const DropdownMenuContainer = styled.div`
  position: absolute;
  min-width: 200px;
  background: #ffffff;
  border: 1px solid ${({ theme }) => theme.colors.main.primary};
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  top: 100%;
  right: 0;
  margin-top: 8px;
`;

const DropdownItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;
  gap: 10px;
  height: 40px;
  border-radius: ${({ isHovered }) => (isHovered ? "4px" : "0px")};
  background-color: ${({ isHovered }) =>
    isHovered ? "#edf8ff" : "transparent"};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #edf8ff;
    border-radius: 4px;
    font-weight: 700;
  }
`;

const DropdownItemText = styled.span`
  font-size: 14px;
  line-height: 21px;
  color: ${({ isBold }) => (isBold ? '#06100f' : '#3c4d4b')};
`;

const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const ThreeDotDropdown = ({ options = [], onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleItemClick = option => {
    if (onSelect) {
      onSelect(option);
    }
    setIsOpen(false);
  };

  return (
    <DropdownWrapper ref={dropdownRef}>
      <IconBox onClick={() => setIsOpen(!isOpen)}>
        <IconImage src={threeDotIcon} alt="menu" />
      </IconBox>

      {isOpen && (
        <DropdownMenuContainer>
          {options && options.length > 0 ? (
            options.map((option, index) => (
              <DropdownItem key={index} onClick={() => handleItemClick(option)}>
                {option.label}
              </DropdownItem>
            ))
          ) : (
            <DropdownItem disabled style={{ pointerEvents: 'none' }}>
              <DropdownItemText>No Options</DropdownItemText>
            </DropdownItem>
          )}
        </DropdownMenuContainer>
      )}
    </DropdownWrapper>
  );
};

export default ThreeDotDropdown;